import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3b085f5e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3b085f5e&prod&scoped=true&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=3b085f5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b085f5e",
  null
  
)

export default component.exports